export default __webpack_public_path__ + "static/media/anima1-2.e5ed1a5e.mp4";